module.exports = __webpack_public_path__ + "img/img-ffp-2@2x.0312ccf5.jpg";